// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"48af4c0b","314":"36ad82f3"}[chunkId] + ".chunk.js";
};